import {skipToken} from '@reduxjs/toolkit/query';

import {useLanesForDocument} from 'app/lanes/api';

import type {ProcedureTaskCoreWithVersion, TaskCore} from 'sweet-taskinfo';

export function useFetchTaskLanes(taskCore: TaskCore | null): void {
  useLanesForDocument(
    // ensure task version wasn't deleted
    taskCore == null || !taskCore.hasVersion
      ? // if there's no version, skip the fetch
        skipToken
      : // so know we know there's a taskCore.version.
      // so now let's check the TaskCore type
      taskCore.ct === 'procedure'
      ? // ok it's a ProcedureTaskCoreWithVersion
        extractAssignedDocumentInfo(taskCore)
      : // at this point we know it's a process based task (ProcessTaskCoreWithVersion)
        {
          // so use taskCore.version which represents the assigned process
          object_ids: taskCore.version.id,
          content_type: taskCore.version.content_type,
        }
  );
}

function extractAssignedDocumentInfo({version}: ProcedureTaskCoreWithVersion):
  | {
      object_ids: number;
      content_type: 'procedureversion' | 'procedure';
      page_size?: number;
    }
  | typeof skipToken {
  /*
    receives a ProcedureTaskCoreWithVersion object, identify the assigned document, and
    return the proper filters to fetch the lanes related to that document.

    The assigned document can be:
        - a procedure, on process-based tasks
        - a procedureversion on procedure-based tasks

    Yes, it can be ProcedureTaskCoreWithVersion and a process-based task at the same time.
    That happens when you are working with a procedure of a process-based task.

    grep for ProcedureTaskCoreWithVersion.constructor code to understand better how it's
    different for each case.
    */

  // if version has a content_type field, version is a procedureversion
  if (
    'content_type' in version &&
    version.content_type === 'procedureversion'
  ) {
    return {
      object_ids: version.id,
      content_type: version.content_type,
    };
    // if version has a type field, it's a procedure step field from a process
  } else if ('type' in version && version.type === 'processprocedure') {
    return {
      object_ids: version.procedure_id,
      content_type: 'procedure',
    };
  }

  // unkonwn version type - it should never happen (unless we mess up the serializer fields)
  return skipToken;
}
